import React, { useEffect } from "react";
import "../css/delivery.scss";

function Delivery() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="main-content">
      <div className="shopify-policy__container">
        <div className="shopify-policy__title">
          <h1>Delivery Information</h1>
        </div>

        <div className="shopify-policy__body">
          <div className="rte">
            <h2>UK Delivery Options</h2>
            <p>
              We offer a range of delivery options to get your order to you as
              quickly and efficiently as possible. All orders are sent tracked.
            </p>

            <ul>
              <li>
                <strong>Standard Delivery:</strong> £4.95 (Free on orders over
                £75). Delivered within 3-5 business days.
              </li>
              <li>
                <strong>Next Day Delivery:</strong> £7.95. Order by 2pm Monday -
                Thursday for next working day delivery.
              </li>
              <li>
                <strong>Saturday Delivery:</strong> £12.00. Order by 2pm Friday.
              </li>
            </ul>

            <h2>International Shipping</h2>
            <p>
              We ship worldwide. International shipping rates are calculated at
              checkout based on the weight and destination of your order.
            </p>
            <ul>
              <li>
                <strong>Europe:</strong> From £12.00. Estimated delivery 5-7
                business days.
              </li>
              <li>
                <strong>USA & Canada:</strong> From £15.00. Estimated delivery
                7-10 business days.
              </li>
              <li>
                <strong>Rest of World:</strong> From £20.00. Estimated delivery
                10-14 business days.
              </li>
            </ul>

            <h2>Order Processing</h2>
            <p>
              Orders are typically processed and dispatched within 1-2 business
              days. During busy periods, such as sales or product launches,
              processing times may be slightly longer.
            </p>
            <p>
              Once your order has been dispatched, you will receive a
              confirmation email with tracking information.
            </p>

            <h2>Customs & Duties</h2>
            <p>
              Please note that for international orders, customs duties and
              taxes may apply. These charges are the responsibility of the
              recipient and are not included in our shipping rates.
            </p>

            <h2>Questions?</h2>
            <p>
              If you have any questions about your delivery, please contact our
              customer service team at draft@pedarcircle.club or visit our Help
              Centre.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Delivery;
